import { AxiosResponse } from 'axios';
import { SertifikatPengetahuan, Data } from '../../entities/SertifikatPengetahuan';

export class SertifikatPengetahuanTTEDataMapper {
  public convertSertifikatPengetahuanTTEData(result: AxiosResponse<any>): SertifikatPengetahuan {
    const res = result.data;

    const dataItems: Data[] = res.data.map((d: any) => ({
      id: d.id,
      title: d.title,
      jenis_pengetahuan: d.jenis_pengetahuan,
      is_klinik_khusus: d.is_klinik_khusus,
      tipe_klinik_khusus: d.tipe_klinik_khusus,
      jadwal_mulai: d.jadwal_mulai,
      jadwal_selesai: d.jadwal_selesai,
      count_status_tte_belum: d.count_status_tte_belum,
      count_status_tte_proses: d.count_status_tte_proses,
      count_status_tte_gagal: d.count_status_tte_gagal,
      count_status_tte_selesai: d.count_status_tte_selesai,
      count_peserta_selesai: d.count_peserta_selesai,
      count_pemateri_children: d.count_pemateri_children,
      review_count: d.review_count,
      rata_rata_rating: d.rata_rata_rating,
      count_review_excellent: d.count_review_excellent,
      count_review_verry_good: d.count_review_verry_good,
      count_review_average: d.count_review_average,
      count_review_poor: d.count_review_poor,
      count_review_terrible: d.count_review_terrible,
      count_peserta: d.count_peserta,
    }));

    return new SertifikatPengetahuan(
          res.current_page,
          dataItems,
          res.first_page_url,
          res.from,
          res.last_page,
          res.last_page_url,
          res.next_page_url,
          res.path,
          res.per_page,
          res.prev_page_url,
          res.to,
          res.total
    );
  }
}
